export default __webpack_public_path__ + "static/media/spam_bot.faa514cd.png";